import React from 'react'
import { Line } from 'react-chartjs-2'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'
import ShimmerEffect from '../ui/ShimmerEffect'

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
)

const options = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
    },
  },
  scales: {
    y: {
      min: 0,
      max: 100,
    },
  },
}

export default function AverageMarksChart({ data = [], loading }) {
  if (loading) {
    return <ShimmerEffect className="h-[300px] w-full rounded-lg" />
  }

  if (!data.length) {
    return <p>No data available to display</p>
  }

  const chartData = {
    labels: data.map(d => `${d.month} ${d.year}`),
    datasets: [
      {
        data: data.map(d => d.value),
        borderColor: 'rgb(147, 51, 234)',
        backgroundColor: 'rgba(147, 51, 234, 0.5)',
        tension: 0.4,
      },
    ],
  }

  return <Line options={options} data={chartData} />
}